import { useCallback, useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import NavBar from "../Components/Navbars/main";
import Sidebar from "../Components/Sidebars/main";
import Footer from "../Components/common/footer";
import ActionBarComponent from "../Components/common/ActionBarComponent";
import PhotoTab from "../Components/new-client-dashboard/tabs/photo-tab/photo";
import NotesSectionDashboard from "../Components/NotesSectionDashboard/main";
// import TabsClient from "../Components/new-client-dashboard/Tabs";
// import TabsClientNew from "../Components/new-client-dashboard/NewTabs";
import AccidentTab from "../Components/CaseAccident/new-case-accident/accident-tab";
import { fetchPageObject, fetchShakespeareStatus, getCaseId, getClientId } from "../Utils/helper";
import { fetchAccidentData } from "../Redux/accident/accidentSlice";
// import NewChangesTabs from "../Components/new-client-dashboard/NewChangesTabs";
// import MoreChangesTab from "../Components/new-client-dashboard/MoreChangesTab";
import LocationMapTab from "../Components/CaseAccident/new-case-accident/locationMap-Tab";
import AccidentTimeLineTab from "../Components/CaseAccident/new-case-accident/AccidentTimeLineTab";
// import PropertyDamageTab from "../Components/CaseAccident/new-case-accident/propertyDamageTab";
// import TreatmentTabs from "../Components/TreatmentPage/TreatmentTabs";
import addIconGold from "../assets/Add-icon-gold.svg";
import AccidentTimelineModal from "../Components/CaseAccident/new-case-accident/modals/accidentTimelineModal";
import AddEditPropertyDamage from "../Components/Property-Damage/tabs/modals/add-edit-property-damage";
import PropertyDamageTab from "../Components/Property-Damage/tabs/property-damage-tab";
import usePropertyDamage from "../Components/Property-Damage/hooks/useGetPropertyDamage";
import SmartResponsiveTabsContainer from "../Components/DefendantPage/DefandantMain/components/ResponsiveTabDefendants";

const PAGE_TITLES = {
  all: "Accident",
  locationMap: "Location Map",
  propertyDamage: "Property Damage",
  accidentTimeline: "Accident Timeline",
  photo: "Photos",
};

const PageTitle = ({ currentPage }) => (
  <div
    style={{
      width: "100%",
      justifyContent: "flex-start",
      background: "var(--primary)",
      height: "25px",
      // marginBottom: "5px",
    }}
  >
    <span
      className="fw-bold text-white"
      style={{
        height: "25px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      {PAGE_TITLES[currentPage]}
    </span>
  </div>
);

const PageContent = ({ currentPage, data, refetch, setAddPropertyDmgModal, pageIcon }) => {
  switch (currentPage) {
    case "all":
      return <AccidentTab />;
    case "locationMap":
      return <LocationMapTab />;
    case "propertyDamage":
      return (
        <PropertyDamageTab
          setAddPropertyDmgModal={setAddPropertyDmgModal}
          data={data}
          refetch={refetch}
          pageIcon={pageIcon}
        />
      );
    case "accidentTimeline":
      return <AccidentTimeLineTab />;
    case "photo":
      return <PhotoTab pageId={5} pageName={"Accident"} />;
    default:
      return null;
  }
};

const AccidentPage = () => {
  const [currentPage, setCurrentPage] = useState("all");
  const dispatch = useDispatch();
  const clientId = getClientId();
  const caseId = getCaseId();
  const [pageObject, setPageObject] = useState(null);
  const { propertyDamage, refetch } = usePropertyDamage();
  const accidentData = useSelector((state) => state.accident.current);
  const accidentTypeName = accidentData?.accident_type?.name?.trim();

  useEffect(() => {
    if (caseId && !pageObject) {
      fetchPageObject(caseId, 5).then((data) => {
        setPageObject(data);
      });
    }
  }, [caseId, pageObject]);

  useEffect(() => {
    dispatch(fetchAccidentData(clientId, caseId));
    // sending page ids directly now.
    fetchShakespeareStatus(caseId, 5, dispatch);
  }, [caseId, clientId, dispatch]);

  const handlePageChange = useCallback((pageType) => {
    setCurrentPage(pageType);
  }, []);

  const mainTabs = useMemo(
    () => [
      {
        id: "all",
        label: accidentTypeName ? `${accidentTypeName} Accident` : "Accident",
        className: "tab-trapezium-cycles-corners",
        background: "var(--primary-5)",
        activeColor: "white",
        onClick: () => handlePageChange("all"),
        leftHand: false,
      },
      {
        id: "locationMap",
        label: "Location Map",
        className: "tab-trapezium-cycles-corners",
        background: "var(--primary-5)",
        activeColor: "white",
        onClick: () => handlePageChange("locationMap"),
        leftHand: false,
      },
      {
        id: "propertyDamage",
        label: "Property Damage",
        className: "tab-trapezium-cycles-corners",
        background: "var(--primary-5)",
        activeColor: "white",
        onClick: () => handlePageChange("propertyDamage"),
        leftHand: false,
      },
      {
        id: "accidentTimeline",
        label: "Accident Timeline",
        className: "tab-trapezium-cycles-corners",
        background: "var(--primary-5)",
        activeColor: "white",
        onClick: () => handlePageChange("accidentTimeline"),
        leftHand: false,
      },
    ],
    [accidentTypeName, handlePageChange]
  );

  const photoTabs = useMemo(
    () => [
      {
        id: "photo",
        label: "Photos",
        className: "tab-trapezium-cycles-corners",
        background: "var(--primary-50)",
        activeColor: "white",
        left: "0px",
        onClick: () => handlePageChange("photo"),
        leftHand: true,
        span: (
          <span
            style={{
              width: "15px",
              height: "15px",
            }}
            className="fw-bold d-flex align-items-center justify-content-center text-gold"
          >
            <img
              src={
                "https://simplefirm-bucket.s3.amazonaws.com/static/images/photo-icon-color_2CyRX1a_GgdCtlG.svg"
              }
              style={{
                width: "15px",
                height: "15px",
              }}
              alt="Detail"
            />
          </span>
        ),
      },
    ],
    []
  );

  const [sideBarCollapsed, setSideBarCollapsed] = useState(null);

  useEffect(() => {
    const getUserPreferencesFromStorage = () => {
      const preferences = localStorage.getItem("userPreferences");
      const preferencesObj = preferences ? JSON.parse(preferences) : null;
      setSideBarCollapsed(preferencesObj?.SidebarView);
    };
    getUserPreferencesFromStorage();
  }, []);
  const [addPropertyDmgModal, setAddPropertyDmgModal] = useState(false);
  const [addAccidentTimelineModal, setAccidentTimelineModal] = useState(false);

  const buttonTabs = useMemo(() => {
    const tabs = [];

    // Expert add button with gold icon
    tabs.push({
      id: "propertyDamageAdd",
      label: "Property Damage",
      className: "tab-trapezium-cycles-corners",
      background: "var(--primary-60)",
      left: "0px",
      onClick: () => {
        setAddPropertyDmgModal(true);
      },
      leftHand: true,
      span: (
        <span className="fw-bold  ic-15 d-flex align-items-center">
          <img className="d-flex align-items-center justify-content-center" src={addIconGold} />
        </span>
      ),
    });

    return tabs;
  }, []);

  const buttonTabs2 = useMemo(() => {
    const tabs = [];

    // Expert add button with gold icon
    tabs.push({
      id: "accidentTimelineAdd",
      label: "Accident Timeline Event",
      className: "tab-trapezium-cycles-corners",
      background: "var(--primary-60)",
      left: "0px",
      onClick: () => {
        setAccidentTimelineModal(true);
      },
      leftHand: true,
      span: (
        <span className="fw-bold  ic-15 d-flex align-items-center">
          <img className="d-flex align-items-center justify-content-center" src={addIconGold} />
        </span>
      ),
    });

    return tabs;
  }, []);

  return (
    <>
      <div className={`page-wrapper ${sideBarCollapsed ? "force-collapsed" : ""}`}>
        <Sidebar />
        <div className="page-container overflow-hidden">
          <NavBar flaggedPageName="5" />
          <ActionBarComponent
            src={pageObject?.page_icon}
            // src="https://simplefirm-bucket.s3.amazonaws.com/static/BP_resources/images/icon/car-accident-icon-color.svg"
            page_name={pageObject?.name}
            pageObj={pageObject}
            isChecklist={pageObject?.PageChklst || false}
          />
          <div className="TreatmentPage-main-container invisible-scrollbar">
            <SmartResponsiveTabsContainer
              HandlePage={currentPage}
              tabsData={mainTabs}
              viewTab={[]}
              addTab={
                currentPage === "propertyDamage"
                  ? buttonTabs
                  : currentPage === "accidentTimeline"
                    ? buttonTabs2
                    : []
              }
              photoTab={photoTabs}
              handlePageChange={handlePageChange}
              viewType={""}
              doesHaveAll={false}
            />

            {currentPage !== "photo" && <PageTitle currentPage={currentPage} />}
            <PageContent
              setAddPropertyDmgModal={setAddPropertyDmgModal}
              currentPage={currentPage}
              data={propertyDamage}
              refetch={refetch}
              pageIcon={pageObject?.page_icon}
            />

            <NotesSectionDashboard pageName={"Accident"} />
          </div>
        </div>
      </div>

      <Footer />

      {/* {addPropertyDmgModal && (
        <AddVehicleDamage
          show={addPropertyDmgModal}
          handleClose={() => {
            setAddPropertyDmgModal(false);
            // if (refresh) fetchData();
          }}
          firmName={"Silverthorne Attorneys"}
          caseParties={caseParties}
        />
      )} */}
      {addPropertyDmgModal && (
        <AddEditPropertyDamage
          show={addPropertyDmgModal}
          handleClose={() => setAddPropertyDmgModal(false)}
          isEdit={false}
          refetch={refetch}
        />
      )}
      {addAccidentTimelineModal && (
        <AccidentTimelineModal
          show={addAccidentTimelineModal}
          handleClose={() => {
            setAccidentTimelineModal(false);
            // if (refresh) fetchData();
          }}
          isEdit={false}
        />
      )}
    </>
  );
};

export default AccidentPage;
